import React from 'react'
import './Otcheti.css'

import izbori1 from './files/otchet izbori/otcheti izbori - snimki/писмо.jpeg'
import izbori2 from './files/otchet izbori/otcheti izbori - snimki/репорт 1.png'
import izbori3 from './files/otchet izbori/otcheti izbori - snimki/репорт 2.png'
import izbori4 from './files/otchet izbori/otcheti izbori - snimki/справка средства кандидати.png'
import izbori5 from './files/otchet izbori/otcheti izbori - snimki/справка средства от пол партии.png'
import izbori6 from './files/otchet izbori/otcheti izbori - snimki/спрарвка дарения ФЛ.png'

import gfo2024 from './Годишен финансов отчет.pdf'
import gfoprilojenie2024 from './Приложение към Годишен финансов отчет.pdf'
import otchetizbori from './/Отчети избори 2024г.zip'
import gfo2025 from './GFO 2025.pdf'
import gfoprilojenie2025 from './GFO 2025 prilojenie.pdf'

function Otcheti() {
  return (
    <div className='container'>
        <div className='layout'>
            <div className='title'>ОТЧЕТИ</div>
            <div className='results'>
              <div className='title2'><h3>2024 година</h3></div>
              <h3>Годишен финансов отчет 2024</h3>
              <div>
              <a className="download-button" href={gfo2024} download="НПП Българе - ГФО 2024.pdf">Свали ГФО 2024</a>
              <a className="download-button" href={gfoprilojenie2024} download="НПП Българе - ГФО 2024 (Приложение).pdf">Свали Приложение към ГФО 2024</a>

              <div className='title2'><h3>2025 година</h3></div>
              <h3>Годишен финансов отчет 2025</h3>
             
              <a className="download-button" href={gfo2025} download="НПП Българе - ГФО 2025.pdf">Свали ГФО 2025</a>
              <a className="download-button" href={gfoprilojenie2025} download="НПП Българе - ГФО 2025 (Приложение).pdf">Свали Приложение към ГФО 2025</a>
              
              
              
             
              <h3>Отчети избори 2024</h3>
              <div className='result-box-otcheti'>
                <img className='gfo-img' src={izbori1} alt='pic'/>
                <img className='gfo-img' src={izbori2} alt='pic'/>
                <img className='gfo-img' src={izbori3} alt='pic'/>
                <img className='gfo-img' src={izbori4} alt='pic'/>
                <img className='gfo-img' src={izbori5} alt='pic'/>
                <img className='gfo-img' src={izbori6} alt='pic'/>
              </div>
              <a className="download-button" href={otchetizbori} download="Отчети избори 2024г.zip">Свали Отчети Избори 2024</a>
              </div>
              <div className='media-partners'>
                <p>Медийни Партньори</p>
                <p>Диян Бояджиев ЕООД</p>
              </div>
              
            </div>
            
        </div>
    </div>
  )
}

export default Otcheti